import { createContext, useContext } from "react";

export const FeedbacksContext = createContext({
  feedbacks: [],
  updateFeedbacks: () => {},
  isEmptyFeedbacks: () => {},
  fetchFeedbacks: () => {},
  reloadFeedbacks: () => {},
  FeedbackDeletedHandler: () => {},
  adminFetchFeedbacks: () => {},
  HideFeedbacksSkeleton: true,
  isUpdatedFeedbacks: false,
  FeedbacksError: null,
  setHideFeedbacksSkeleton: () => {},
  removeFeedbacks: () => {},
});

export const useFeedbacksContext = () => useContext(FeedbacksContext);
